/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1SerievideoIdMutationRequest,
  PutApiV1SerievideoIdMutationResponse,
  PutApiV1SerievideoIdPathParams,
  PutApiV1SerievideoIdQueryParams,
  PutApiV1SerievideoId400,
  PutApiV1SerievideoId401,
  PutApiV1SerievideoId404,
  PutApiV1SerievideoId500,
} from "../../types/serieVideoRegistroController/PutApiV1SerievideoId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1SerievideoId } from "../../clients/serieVideoRegistroController/putApiV1SerievideoId.ts";

export const putApiV1SerievideoIdMutationKey = () =>
  [{ url: "/api/v1/serievideo/:id" }] as const;

export type PutApiV1SerievideoIdMutationKey = ReturnType<
  typeof putApiV1SerievideoIdMutationKey
>;

export function putApiV1SerievideoIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1SerievideoIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1SerievideoIdMutationKey();
  return mutationOptions<
    PutApiV1SerievideoIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerievideoId400
      | PutApiV1SerievideoId401
      | PutApiV1SerievideoId404
      | PutApiV1SerievideoId500
    >,
    {
      id: PutApiV1SerievideoIdPathParams["id"];
      data?: PutApiV1SerievideoIdMutationRequest;
      params?: PutApiV1SerievideoIdQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data, params }) => {
      return putApiV1SerievideoId(id, data, params, config);
    },
  });
}

/**
 * @description Atualiza um vídeo (multipart/form-data). Atualiza título/resumo/embed no idioma corrente e permite substituir ou remover a imagem de capa. **(Requer Authorization para autenticação)**
 * @summary Atualizar vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:id}
 */
export function usePutApiV1SerievideoId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1SerievideoIdMutationResponse,
      ResponseErrorConfig<
        | PutApiV1SerievideoId400
        | PutApiV1SerievideoId401
        | PutApiV1SerievideoId404
        | PutApiV1SerievideoId500
      >,
      {
        id: PutApiV1SerievideoIdPathParams["id"];
        data?: PutApiV1SerievideoIdMutationRequest;
        params?: PutApiV1SerievideoIdQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiV1SerievideoIdMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1SerievideoIdMutationKey();

  const baseOptions = putApiV1SerievideoIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1SerievideoIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerievideoId400
      | PutApiV1SerievideoId401
      | PutApiV1SerievideoId404
      | PutApiV1SerievideoId500
    >,
    {
      id: PutApiV1SerievideoIdPathParams["id"];
      data?: PutApiV1SerievideoIdMutationRequest;
      params?: PutApiV1SerievideoIdQueryParams;
    },
    TContext
  >;

  return useMutation<
    PutApiV1SerievideoIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerievideoId400
      | PutApiV1SerievideoId401
      | PutApiV1SerievideoId404
      | PutApiV1SerievideoId500
    >,
    {
      id: PutApiV1SerievideoIdPathParams["id"];
      data?: PutApiV1SerievideoIdMutationRequest;
      params?: PutApiV1SerievideoIdQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1SerievideoIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerievideoId400
      | PutApiV1SerievideoId401
      | PutApiV1SerievideoId404
      | PutApiV1SerievideoId500
    >,
    {
      id: PutApiV1SerievideoIdPathParams["id"];
      data?: PutApiV1SerievideoIdMutationRequest;
      params?: PutApiV1SerievideoIdQueryParams;
    },
    TContext
  >;
}
